import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import {
  TAB_CONFIG,
  TRANSLATION_PREFIX,
  TabId
} from "@/components/global/Chat/components/meetingPrep/consts";

// Figma lays out the 59x64 hexagon, not the padded canvas the art sits in.
const EMPTY_ILLUSTRATION_BOX = "relative h-[64px] w-[59px] shrink-0";
const EMPTY_ILLUSTRATION_ART =
  "absolute left-[-15.5px] top-[-3.5px] max-w-none";

const MeetingPrepEmptyState: React.FC<{ tab: TabId }> = ({ tab }) => {
  const { t } = useTranslation();
  const Illustration = TAB_CONFIG[tab].emptyIllustration;

  return (
    <div
      className="flex flex-col items-center justify-center gap-6 min-h-full p-6 text-center"
      data-test={`meeting-prep-empty-${tab}`}
    >
      <div className={EMPTY_ILLUSTRATION_BOX}>
        <Illustration className={EMPTY_ILLUSTRATION_ART} />
      </div>
      <Text variant="body" className="normal-case">
        {t(`${TRANSLATION_PREFIX}.empty.${tab}`)}
      </Text>
    </div>
  );
};

export default MeetingPrepEmptyState;
